import { AttitudeCategory } from '../services/types'

interface AttitudeCardProps {
  attitude: AttitudeCategory
  isSelected: boolean
  onToggle: (id: number) => void
}

export const AttitudeCard = ({ attitude, isSelected, onToggle }: AttitudeCardProps) => {
  const isPositive = attitude.type === 'positive'
  const pointsDisplay = isPositive ? `+${attitude.points}` : attitude.points

  return (
    <div
      className={`bg-white dark:bg-gray-800 rounded-card border-2 transition-all ${
        isSelected
          ? isPositive
            ? 'border-success shadow-md'
            : 'border-danger shadow-md'
          : 'border-gray-200 dark:border-gray-700'
      }`}
    >
      <div className="p-6">
        {/* Header: Name + Points */}
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
            {attitude.name}
          </h3>
          <span
            className={`text-2xl font-bold ${
              isPositive ? 'text-success' : 'text-danger'
            }`}
          >
            {pointsDisplay}
          </span>
        </div>

        {/* Question */}
        <p className="text-gray-600 dark:text-gray-400 mb-4 min-h-[48px]">
          {attitude.question}
        </p>

        {/* Buttons */}
        <div className="flex gap-3">
          {/* Sim Button */}
          <button
            onClick={() => onToggle(attitude.id)}
            className={`flex-1 py-3 rounded-btn font-medium transition-all ${
              isSelected
                ? isPositive
                  ? 'bg-success text-white shadow-md scale-105'
                  : 'bg-danger text-white shadow-md scale-105'
                : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
            }`}
          >
            Sim
          </button>

          {/* Não Button */}
          <button
            onClick={() => !isSelected && null}
            className={`flex-1 py-3 rounded-btn font-medium transition-colors ${
              !isSelected
                ? 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300'
                : 'bg-gray-100 dark:bg-gray-800 text-gray-400 dark:text-gray-600'
            }`}
            disabled={!isSelected}
          >
            Não
          </button>
        </div>
      </div>
    </div>
  )
}

export default AttitudeCard
